
import Vue from 'vue'
import { TITLES_REF, arrayRef } from '@/models/refs'

export default Vue.extend({
    name: 'TitleSelector',
    props: ['values'],
    data() {
        return {
            selected: [] as string[],
            options: arrayRef(TITLES_REF),
        }
    },
    mounted() {
        this.selected = this.values
    },
    methods: {
        change() {
            this.$emit('onChange', this.selected as string[])
        },
    },
})
